import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=1a9ed240&"
import script from "./OrderView.vue?vue&type=script&lang=js&"
export * from "./OrderView.vue?vue&type=script&lang=js&"
import style0 from "./OrderView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports